import { BaseModel } from './base.model';
import { Requirement } from './requirement.model';
import {
  EstimationSource,
  EstimationSourceSubtype,
  EstimationConfidence,
  EstimationDiffStatus,
  CanonicalSignature
} from './estimation-v3.types';

export interface Task {
    id: number;
    name: string;
    description: string;
    type: string;
    requirement: Requirement;
    subsystem: string;
    profile: string;
    technology: string;
    estimatetime: number;
    source?: EstimationSource;

    // ===== Campos v3 (todos opcionales para retrocompatibilidad) =====
    source_subtype?: EstimationSourceSubtype;
    canonical_signature?: CanonicalSignature;
    specifics?: string[];
    ai_assistance_factor?: number;
    calibration_factor_applied?: number;
    freshness_weight_applied?: number;
    confidence?: EstimationConfidence;
    p10_hours?: number;
    p90_hours?: number;
    analog_project_ids?: string[];

    // ===== Edición local (data provenance) =====
    _original?: any;
    _isModified?: boolean;

    // ===== Estado del diff view (ya se usaban en HTML, ahora tipados) =====
    _diffStatus?: EstimationDiffStatus;
    _oldHours?: number;
    _oldType?: string;
    _oldSubsystem?: string;
    _oldTechnology?: string;
    _oldProfile?: string;
    _oldDescription?: string;
}

export class Task implements BaseModel {
  id: number;
  name: string;
  description: string;
  type: string;
  requirement: Requirement;
  subsystem: string;
  profile: string;
  technology: string;
  estimatetime: number;
  source?: EstimationSource;

  // Campos v3
  source_subtype?: EstimationSourceSubtype;
  canonical_signature?: CanonicalSignature;
  specifics?: string[];
  ai_assistance_factor?: number;
  calibration_factor_applied?: number;
  freshness_weight_applied?: number;
  confidence?: EstimationConfidence;
  p10_hours?: number;
  p90_hours?: number;
  analog_project_ids?: string[];

  // Edición local
  _original?: any;
  _isModified?: boolean;

  // Diff view
  _diffStatus?: EstimationDiffStatus;
  _oldHours?: number;
  _oldType?: string;
  _oldSubsystem?: string;
  _oldTechnology?: string;
  _oldProfile?: string;
  _oldDescription?: string;

  constructor();
  constructor(id: number, name: string, description: string, type: string, requirement: Requirement, subsystem: string, profile: string, technology: string, estimatetime: number, source?: EstimationSource);

  constructor(id?: number, name?: string, description?: string, type?: string, requirement?: Requirement, subsystem?: string, profile?: string, technology?: string, estimatetime?: number, source?: EstimationSource) {
    if (id !== undefined) {
      this.id = id;
    }
    if (name !== undefined) {
      this.name = name;
    } else {
      this.name = '';
    }

    if (description !== undefined) {
      this.description = description;
    } else {
      this.description = '';
    }

    if (type !== undefined) {
      this.type = type;
    } else {
      this.type = '';
    }

    if (requirement !== undefined) {
      this.requirement = requirement;
    } else {
      this.requirement = {} as Requirement;
    }

    if (subsystem !== undefined) {
      this.subsystem = subsystem;
    } else {
      this.subsystem = '';
    }

    if (profile !== undefined) {
      this.profile = profile;
    } else {
      this.profile = '';
    }

    if (technology !== undefined) {
      this.technology = technology;
    } else {
      this.technology = '';
    }

    if (estimatetime !== undefined) {
      this.estimatetime = estimatetime;
    } else {
      this.estimatetime = 0;
    }

    if (source !== undefined) {
        this.source = source;
    }
  }

  getApiName(): string {
    return 'tasks';
  }

  getName(): string {
    return 'Tarea';
  }

  getNamePl(): string {
    return 'Tareas';
  }
}